
import {timer as observableTimer,  Observable ,  Subscription } from 'rxjs';
import {
	Directive,
	Component,
	Input,
	OnInit,
	Output,
	SimpleChanges,
	EventEmitter,
} from "@angular/core";

@Component({
	selector: "app-bullets",
	templateUrl: "./bullets.html",
	styleUrls: ["./bullets.css"],
})
export class BulletsDirective {
	@Input()
	public bullets: any[];
	@Input()
	public delay: number;
	@Output()
	public complete: EventEmitter<any> = new EventEmitter();

	private subscription: Subscription;
	public arrBullets: any[];

	constructor() {}

	public ngOnChanges(simplechanges: SimpleChanges) {
		if (this.bullets && this.arrBullets == null) {
			this.arrBullets = this.bullets;
			if (!this.delay) {
				this.complete.emit();
			} else {
				this.setBullets(this.arrBullets);
			}
		}
	}
	public setBullets(arr) {
		let timer = observableTimer(this.delay, this.delay);
		this.subscription = timer.subscribe((t) => {
			this.makeVisible(arr[t], t == arr.length - 1);
		});
	}
	private makeVisible(bullet, stop) {
		console.log("add bulets  ", stop);
		if (bullet) {
			bullet.visible = true;
		}
		if (stop) {
			this.complete.emit();
			this.subscription.unsubscribe();
		}
	}

	/*private addBullets(bullet,stop){
    console.log("add bulets  ", stop);
    this.arrBullets.push(bullet);
    if(stop){
        this.complete.emit();
        this.subscription.unsubscribe();
    }
  }*/
}
